function getIdSelector(id) {
  return `#${id}`
}

export const ELEMENT_ID = {
  ABOUT_SECTION: 'about',
  CATEGORIES_SECTION: 'categories',
  JUDGES_SECTION: 'judges',
  JUDGES_SECTION_HOMEPAGE: 'judges-homepage',
  HP_LEAD_FORM: 'nominate',
  VOTE_FORM: 'vote',
  VOTE_SUCCESS_MESSAGE: 'vote-success-message',
  VOTE_FORM_SUBMIT_BUTTON: 'submit-vote-btn',
  AUTH_MODAL: 'auth-modal-wrapper',
  WINNERS_SECTION: 'winners'
}

export const ELEMENT_SELECTOR_BY_ELEMENT_ID = Object.entries(ELEMENT_ID).reduce(
  (acc, [, value]) => ({
    ...acc,
    [value]: getIdSelector(value)
  }),
  {}
)
